import Modal from "react-modal";
import {X} from "react-feather";
import {Alert} from "flowbite-react";
import {InfoCircle} from "flowbite-react-icons/outline";
import React from "react";

const ModalOneAccountVendor = ({handleClose, title}) => {
    return <Modal
        isOpen={true}
        onRequestClose={handleClose}
        className="sl-modal-content sl-max-h-185"
        overlayClassName="sl-modal sl-block sl-rounded-md sl-bg-gray-900-opacity-50">
        <div className="">
            <div
                className="sl-modal-header sl-rounded-md sl-flex sl-justify-between sl-bg-gray-50 sl-text-gray-900 sl-px-6 sl-py-16 sl-border-bottom">
                <div className="sl-font-semibold sl-text-lg sl-mr-auto sl-ml-0">
                    <div>{title}</div>
                </div>
                <div className="sl-cursor-pointer sl-btn-link-gray sl-mr-0" onClick={handleClose}>
                    <X/>
                </div>
            </div>

            <div
                className="sl-modal-body sl-h-auto sl-max-h-112 sl-customized-scrollbar sl-overflow-y-auto sl-px-6 sl-pb-0 sl-pt-24 sl-flex sl-flex-col sl-gap-3">
                <Alert color={"white"}
                       className={"sl-bg-gray-25 sl-border-gray-300 sl-border-1 sl-border-solid sl-border-radius-8"}
                       additionalContent={<span
                           className="sl-ml-36 sl-text-gray-500 sl-font sl-text-sm sl-font-normal">Invite your team members to forward conversations.</span>}
                       icon={InfoCircle}>
                         <span
                             className={"sl-text-gray-700 sl-font sl-text-md sl-font-medium"}>
                You’re the only user in your company.</span>
                </Alert>
            </div>


            <div className="sl-modal-footer sl-px-6 sl-py-32">
                <div
                    className="sl-flex sl-justify-end sl-gap-2-point-5 sl-bg-white sl-rounded-bottom-left-xl sl-rounded-bottom-right-xl sl-mt-0i sl-font sl-text-md sl-font-normal">

                    <button onClick={handleClose}
                            className="sl-btn sl-btn-clear sl-btn-lg sl-rounded-lg sl-border-gray-300 sl-border-1 sl-border-solid ">
                        Close
                    </button>

                </div>
            </div>
        </div>
    </Modal>;
}

export default ModalOneAccountVendor;